import Vue from 'vue/dist/vue.esm'

import Datenschutz from './components/Datenschutz.vue'

Vue.config.productionTip = false


new Vue({
  el: "#datenschutz",
  components: { Datenschutz }
})